import { parseBooleanValue } from "../../util";
import { ICourtCaseConnectionType } from "../model/CourtCaseConnectionType";

const CourtCaseConnectionTypeParamMapper = (item: ICourtCaseConnectionType) => {
  return {
    ...item,
    valid: parseBooleanValue(item.valid)
  };
};

export default CourtCaseConnectionTypeParamMapper;
